export default __webpack_public_path__ + "static/media/logo-globalgap.280805d6.svg";